import { makeStyles } from '@material-ui/core'
import React from 'react'
import { gcsURL } from '../../utils/gcsUrl'
import { SHERWIN_WILLIAMS_LOGO } from '../constants/AppImages'

const styles = makeStyles({
  bg: {
    height: '600px',
    backgroundImage: `url(${gcsURL(
      'app/cv/shw/app_images',
      SHERWIN_WILLIAMS_LOGO
    )}`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
  },
  message: {
    fontSize: '20px',
    textAlign: 'center',
    marginTop: '5%',
  },
})

// Display the first building's first view's thumbnail as the representative
// view of the property.
const InactivePage = () => {
  const classes = styles()
  return (
    <React.Fragment>
      <div className={classes.bg}>
        <div className={classes.message}>
          The status of your requested project has been set to inactive. Please
          contact a Sherwin-Williams representative to restore the status of
          this project to active.
        </div>
      </div>
    </React.Fragment>
  )
}

export { InactivePage }
